<template>
  <div class="iprdb_login_wrapper">
    <div id="login_container">
      <div class="brand">
        <img class="hand"
             @click="goIndex"
             src="../assets/images/index/brand.png" />
      </div>
      <div class="form_box">
        <div class="earth_box">
          <div class="earth_title">知嘟嘟专利检索平台</div>
          <img class="earth_img"
               src="../assets/images/index/earth.png" />
        </div>
        <div class="login_box">
          <div class="login_title">
            登录
          </div>
          <div class="login_input_wrapper">
            <v-text-field v-model="userName"
                          label="用户名"
                          height="36"
                          hide-details
                          outlined></v-text-field>
          </div>
          <div class="login_input_wrapper">
            <v-text-field v-model="password"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          label="密码"
                          outlined
                          height="36"
                          hide-details
                          @click:append="show1 = !show1"></v-text-field>
          </div>
          <div class="login_btn">
            <div class="login_btn_title"
                 @click="goLogin">
              登录
            </div>
            <div class="login_btn_shadow"></div>
          </div>
          <div class="login_tip_box">
            <div class="tip_txt">注册</div>
            <div class="tip_txt">忘记密码</div>
          </div>
          <div class="third_service_box">
            第三方账号登录
          </div>
          <div class="wechat_and_qq_box">
            <img src="../assets/images/index/weixin.png" />
            <img src="../assets/images/index/qq.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="login_page"
         v-if="false">
      <!-- <div class="tips_title">临港松江科技城知识产权管理系统</div> -->
      <div class="tips_title">IPRDB知识产权管理系统</div>
      <div class="login_box">
        <div class="box_cons">
          <div class="title">登录</div>
          <div class="cons">
            <div class="line">
              <v-text-field v-model="userName"
                            label="用户名"
                            height="36"
                            hide-details
                            outlined></v-text-field>
            </div>
            <div class="login_box">
                <div class="login_title">
                登录
                </div>
                <div class="login_input_wrapper">
                    <v-text-field
                        v-model="userName"
                        label="用户名"
                        height="36"
                        hide-details
                        outlined
                    ></v-text-field>
                </div>
                <div class="login_input_wrapper">
                    <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        label="密码"
                        outlined
                        height="36"
                        hide-details
                        @click:append="show1 = !show1"
                    ></v-text-field>
                </div>
                <div class="login_btn">
                <div class="login_btn_title" @click="goLogin">
                    登录
                </div>
                <div class="login_btn_shadow"></div>
                </div>
                <div class="login_tip_box">
                    <!-- 注册 -->
                <div class="tip_txt"></div>
                <div class="tip_txt">忘记密码</div>
                </div>
                <div class="third_service_box">
                第三方账号登录
                </div>
                <div class="wechat_and_qq_box">
                <img src="../assets/images/index/weixin.png" />
                <img src="../assets/images/index/qq.png" />
                </div>
            </div>
            <div class="line last">
              <div class="btn"
                   @click="goLogin">
                <v-btn>登录</v-btn>
              </div>
            </div>
            <div class="line_tips">
              <span class="text">注册</span>
              <span class="text">忘记密码</span>
            </div>
            <div class="line_bottom">
              <div class="tit1">第三方账号登录</div>
              <div class="icon_box">
                <div class="item wechat">
                  <i></i>
                </div>
                <div class="item qq">
                  <i></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      userName: '',
      password: '',
      show1: false
    }
  },
  methods: {
    ...mapActions('common', ['login']),
    goLogin () {
      if (!this.userName || !this.password) {
        this.$message({
          type: 'info',
          message: '请输入用户名或密码'
        })
        return false
      }
      let data = {
        params: {
          account: this.userName,
          password: this.password
        }
      }
      let _this = this
      this.login({        data: data, handle (res) {
          console.log(res)
          if (res.success) {
            localStorage.setItem('ss',res.token)
            _this.$router.push({
              path: '/search'
             
            });
          } else {
            _this.$message({
              type: "error",
              message: res.message || "登录失败",
            });
          }
        }      })
    },
    goIndex () {
      this.$router.push({
        path: '/'
      })
    }

  }
}
</script>